import { fetchAuthSession } from 'aws-amplify/auth';
import { gql, GraphQLClient, Variables } from 'graphql-request';

import { version } from '../../package.json';

const endpoint = process.env.REACT_APP_GRAPHQL_URL ?? '/graphql';
const graphQLClient = new GraphQLClient(
  endpoint.startsWith('/') && typeof location !== 'undefined'
    ? `${location.origin}${endpoint}`
    : endpoint,
);

/**
 * Returns the authorization header
 */
const getAuthorizationHeader = async () => {
  const token = sessionStorage.getItem('authToken');
  if (token) {
    return `Bearer ${token}`;
  }

  try {
    const session = await fetchAuthSession();
    return `Bearer ${session.tokens?.idToken?.toString()}`;
  } catch {
    console.error('No token found');
    return '';
  }
};

/**
 * Send a GraphQL Document to the GraphQL server for exectuion.
 */
const graphQLRequest =
  <TData, TVariables extends Variables>(
    query: string,
    variables?: TVariables,
    options?: HeadersInit,
  ): ((queryParams?: { signal?: AbortSignal }) => Promise<TData>) =>
  async (queryParams) => {
    const headers: Headers = new Headers(options);

    if (process.env.NODE_ENV === 'development') {
      const { getPpnuidHeader } = await import('@porsche-code/kado-devtools');
      const ppnuidHeader = getPpnuidHeader();
      if (ppnuidHeader) {
        const [key, value] = Object.entries(ppnuidHeader)[0];
        headers.set(key, value);
      }
    }

    const token = await getAuthorizationHeader();

    return graphQLClient.request<TData>({
      document: query,
      variables,
      signal: queryParams?.signal,
      requestHeaders: {
        'X-App-Name': 'dashboard',
        'X-App-Version': version,
        Authorization: token,
        ...Object.fromEntries(headers),
      },
    });
  };

export { gql, graphQLRequest as request };
